import { Utils } from '../../../../../../../core/utils/utils';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { Cas } from '../../../../../../../core/entities/cas.model';
import { CasService } from '../../../../../../../core/repositories/cas.service'

@Injectable()
export class EditDialogsCasService {

  cas: Cas = new Cas();
  originalCas: Cas = new Cas();
  CasInput: Cas = new Cas();

  allCas: Cas[] = [];
  changetitulo: boolean = false;

  constructor(private casService: CasService) { }

  /**
  * Inicia el dialog
  * @param data Datos recibidos por el dialog
  */
  init(data: any): Observable<boolean> {
    this.cas = data.ca;
    this.changetitulo = data.titulochange;
    this.originalCas = _.cloneDeep(this.cas);
    console.log(data);
    return this.casService.findAll().pipe(map((result: Cas[]) => {
      this.allCas = result;
      if (Utils.noUndfAndNull(data.ca)) {
        this.cas = _.cloneDeep(data.ca);
      }
      return true;
    }));
  }


  /**
  * @description
  * Guarda el ca
  */
  public guardar(): Observable<any> {
    console.log('guardar');
    if (Utils.noUndfAndNull(this.cas.id, "")) {

      /*comparamos el ca original con el modificado*/
      let compareCa = this.compare(this.cas, this.originalCas);

      if(compareCa){
        return of(-1);
      }else{
        return this.casService.postCa(this.cas);
      }

    } else {
        return this.casService.postCa(this.cas);
    }
  }

  /**
  * @description
  * Comprueba si dos Cas son iguales.
  * @param datoX Ca 1
  * @param datoY Ca 2
  * @returns True si son iguales
  */
  public compare(itemX:Cas, itemY:Cas):boolean {
    //Ambos objetos están definidos y no son nulos
    if (Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY)) {

      if(itemY.id == null){
        if (itemX.code !== "")
          return false;
      }else{
        if ((!Utils.compareTextOrNumber(itemX.code, itemY.code)
        || !Utils.compareTextOrNumber(itemX.cnIssuer, itemY.cnIssuer)
        || !Utils.compareTextOrNumber(itemX.cn, itemY.cn)
        || !Utils.compareTextOrNumber(itemX.cnregexp, itemY.cnregexp)
        || !Utils.compareTextOrNumber(itemX.sn, itemY.sn)
        || !Utils.compareTextOrNumber(itemX.snregexp, itemY.snregexp)
        || !Utils.compareTextOrNumber(itemX.email, itemY.email)
        || !Utils.compareTextOrNumber(itemX.emailregexp, itemY.emailregexp)
        ) && (itemX.code !== ""))
          return false;
      }
    }
   //Uno de los objetos no está definido o es nulo mientras el otro sí está definido
   else if ((Utils.noUndfAndNull(itemX) && !Utils.noUndfAndNull(itemY)) || (!Utils.noUndfAndNull(itemX) && Utils.noUndfAndNull(itemY))) {
     return false;
   }
   return true;
 }

  /**
  * @description
  * Asigna a las propiedades del servicio sus valores por defecto
  */
  build() {
    this.cas = new Cas();
  }

}
